import React from 'react';
import moment from 'moment';

import { USAGE_DATE_FORMAT } from '../../constants';
import getCarrier from 'helpers/getCarrier';
import UpdatePlanButton from './UpdatePlanButton';
import './style.css';
import ChangeMdnButton from './ChangeMdnButton';

export const renderSubscription = (purchaseItem) => {
  if (!purchaseItem) {
    return '';
  }

  if (purchaseItem.hasOwnProperty('tracfone_subscription')) {
    return `${purchaseItem.tracfone_subscription} (Tracfone)`;
  }

  if (purchaseItem.hasOwnProperty('att_subscription')) {
    return `${purchaseItem.att_subscription} (AT&T)`;
  }

  if (purchaseItem.simo_subscription) {
    return `${purchaseItem.simo_subscription} (Simo)`;
  }

  if (purchaseItem.quick_subscription) {
    return `${purchaseItem.quick_subscription} (Quick)`;
  }

  if (purchaseItem.sprint_subscription) {
    return `${purchaseItem.sprint_subscription} (Sprint)`;
  }

  return '';
};

const isUpdatePlan = (item) => {
  if (!item || !item.subscription || !item.subscription.plan) {
    return false;
  }

  if (item.price && item.price.indexOf('-') !== -1) {
    return false;
  }

  // not used for update and not top up
  if (item.simo_subscription) {
    if (
      item.from_date ||
      (item.title && item.title.toLowerCase().includes('top-up'))
    ) {
      return false;
    }
  }

  const sub = item.subscription;
  const carrier = getCarrier(sub);
  const key = `${carrier}_plan`;

  // disabled for sprint
  if (carrier === 'sprint') {
    return false;
  }

  if (item[key] && sub.plan.id !== item[key]) {
    return true;
  }

  return false;
};

const isChangeMdn = (item) => {
  if (!item || item.from_date) {
    return false;
  }

  if (item.price && item.price.indexOf('-') !== -1) {
    return false;
  }

  if (item.item_type === 'mdn_change_fee') {
    return true;
  }

  return false;
};

const PurchaseItem = ({
  itemLine,
  handleOpenModal,
  handleChange,
  isEditState,
  isRefundState,
  lineItemsToRefund,
  actionComponent,
  canChangeOffloadAmount,
  refundError = {},
  purchase,
  isViewPage,
  findPurchase,
}) => {
  const isCompletedPurchase = purchase && purchase.status === 'complete';
  const hasRefundError = refundError.hasError && refundError.id === itemLine.id;
  const refundFieldError = hasRefundError ? 'has-error' : '';

  const lineItemToRefund = lineItemsToRefund.find(
    (item) => item.id === itemLine.id,
  );

  const canShowActionBtn =
    isViewPage &&
    isCompletedPurchase &&
    !purchase?.refunded_by?.length &&
    !purchase?.refund_for;
  const showUpdatePlan = canShowActionBtn && isUpdatePlan(itemLine);
  const showChangeMdn = canShowActionBtn && isChangeMdn(itemLine);

  const openModal = () => {
    handleOpenModal(itemLine.lease, itemLine.id);
  };

  const handleLineChange = (event) => {
    handleChange(itemLine, event.target);
  };

  return (
    <tr>
      {isEditState &&
        (itemLine.from_date && itemLine.to_date ? (
          <td></td>
        ) : (
          <td>
            <input
              id={itemLine.id}
              type="checkbox"
              onChange={handleLineChange}
            />
          </td>
        ))}
      {isRefundState && (
        <td>
          <div className={`${refundFieldError}`}>
            <input
              id={itemLine.id}
              className="form-control"
              type="number"
              min="0"
              step="1"
              onChange={handleLineChange}
              disabled={lineItemToRefund && lineItemToRefund.full_refund}
              value={lineItemToRefund?.refund_amount || ''}
              style={{ maxWidth: '100px', minWidth: '100px' }}
            />
            <span className="checkbox">
              <label>
                <input
                  type="checkbox"
                  onChange={handleLineChange}
                  checked={lineItemToRefund?.full_refund || false}
                />
                Full refund
              </label>
            </span>
            {hasRefundError && (
              <small className="text-danger">{refundError.message}</small>
            )}
          </div>
        </td>
      )}
      <td>{itemLine.id}</td>
      <td>{itemLine.title}</td>
      <td>{itemLine.description}</td>
      <td>
        {itemLine.from_date
          ? itemLine.simo_subscription
            ? moment(itemLine.from_date).utc().format(USAGE_DATE_FORMAT)
            : moment(itemLine.from_date).format(USAGE_DATE_FORMAT)
          : ''}
      </td>
      <td>
        {itemLine.to_date
          ? itemLine.simo_subscription
            ? moment(itemLine.to_date).utc().format(USAGE_DATE_FORMAT)
            : moment(itemLine.to_date).format(USAGE_DATE_FORMAT)
          : ''}
      </td>
      <td>{renderSubscription(itemLine)}</td>
      <td>{itemLine.subscription_iccid || ''}</td>
      <td>{itemLine.subscription_identifier || ''}</td>
      <td>${itemLine.price}</td>
      <td>
        {showUpdatePlan && (
          <UpdatePlanButton
            purchaseId={purchase.id}
            item={itemLine}
            findPurchase={findPurchase}
          />
        )}
        {showChangeMdn && (
          <ChangeMdnButton
            purchaseId={purchase.id}
            userId={purchase.user_profile}
          />
        )}
      </td>
      {canChangeOffloadAmount && (
        <td>
          <button className="button-as-link" onClick={openModal}>
            Change offload amount
          </button>
        </td>
      )}
      {actionComponent && <td>{actionComponent(itemLine)}</td>}
    </tr>
  );
};

export default PurchaseItem;
